import { Image, StyleSheet, View, useWindowDimensions } from 'react-native';

import { Button, Text, tokens, useMqSelect } from '@fhs/ui';

import { StepsProgress } from '../steps-progress';

export interface ChallengeCardProps {
  image: string;
  title: string;
  description: string;
  onPress: () => void;
  buttonText?: string;
  badge?: string;
  progress?: {
    current: number;
    total: number;
    type?: 'percentage' | 'steps';
  } | null;
}

export function ChallengeCard({
  image,
  title,
  description,
  onPress,
  buttonText,
  badge,
  progress,
}: ChallengeCardProps) {
  const itemWidth = useChallengeCardWidth();

  return (
    <View style={[{ width: itemWidth }, styles.card]}>
      <Image source={{ uri: image }} style={{ height: 180 }} />
      <View style={styles.content}>
        {badge && (
          <View style={styles.badge}>
            <Text.Ui size="sm" weight="semibold" style={{ color: tokens.colors.$white }}>
              {badge}
            </Text.Ui>
          </View>
        )}
        <Text.Heading type="four">{title}</Text.Heading>
        <Text.Ui size="sm" style={{ marginTop: 8 }}>
          {description}
        </Text.Ui>
        {progress && (
          <StepsProgress
            style={{ marginTop: 8 }}
            currentStep={progress.current}
            totalSteps={progress.total}
          />
        )}
        {buttonText && (
          <Button size="xs" onPress={onPress} style={{ marginTop: 16 }}>
            <Button.Text>{buttonText}</Button.Text>
          </Button>
        )}
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  card: {
    borderColor: tokens.colors.$blackOpacity10,
    borderWidth: 1,
    borderRadius: 8,
    overflow: 'hidden',
  },
  content: {
    padding: 12,
    borderTopWidth: 1,
    borderColor: tokens.colors.$blackOpacity10,
  },
  badge: {
    backgroundColor: tokens.colors.$success,
    marginBottom: 12,
    paddingHorizontal: 8,
    paddingVertical: 4,
    borderRadius: 4,
    alignSelf: 'baseline',
  },
});

export function useChallengeCardWidth() {
  const { width } = useWindowDimensions();
  const itemWidth = useMqSelect({ $gteDesktop: 908 }, width - 32);

  return itemWidth;
}
